import { gql } from '@apollo/client';

export const GET_TEMU_LABEL_FOR_RELABEL_FOR_EXTERNAL_STAFF = gql`
    query GetTemuLabelForRelabelForExternalStaff($collectionWaybillSn: String!) {
        getTemuLabelForRelabel: getTemuLabelForRelabelForExternalStaff(collectionWaybillSn: $collectionWaybillSn) {
            pdfBase64
            tailWaybillSn
        }
    }
`;
